import { render, staticRenderFns } from "./AppBtnFab.vue?vue&type=template&id=123d90d2&"
import script from "./AppBtnFab.vue?vue&type=script&lang=js&"
export * from "./AppBtnFab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports